export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ArchiveDialog.json?hash=bf62aedf5072a4169f3bd494e7cebdbe";